import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  body: {
    paddingTop: '35px',
    paddingBottom: '65px',
    paddingHorizontal: '35px',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    textAlign: 'center',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: '10px',

    bottom: '30px',
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  pageFlow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  section: {
    border: '1px solid black',
    borderRadius: 5,
    width: '100%',
    padding: '10px',
    margin: '15px 0px',
  },
  POSection: {
    display: 'flex',
    flexDirection: 'row',
  },
  POSectionColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
  poSectionItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    margin: '2px 0px',
  },
  poSectionHeading: {
    width: '50%',
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    fontSize: '10px',
  },
  poSectionValue: {
    width: '50%',
    fontSize: '10px',
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    fontSize: '14px',

    width: '100%',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#aaa',
    margin: '5px 0px',
  },
  description: {
    fontSize: '10px',
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
  },
  contactInfoSection: {
    width: '50%',
  },
  subTitle: {
    fontSize: '12px',
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    marginBottom: '10px',
  },
  table: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#DDDDDD',
    gap: '10px',
  },
  tableBody: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  tableCol: {
    borderStyle: 'solid',
    borderColor: 'white',
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    padding: 2,
  },
  tableHeaderCell: {
    fontSize: '9px',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    margin: 'auto',
  },
  tableCell: {
    fontSize: '8px',
    textAlign: 'left',
  },
  glGLCode: {
    width: '40%',
  },
  glNotes: {
    width: '20%',
  },
  mpaGlGLCode: {
    width: '29%',
  },
  mapGLAcctPeriod: {
    width: '24%',
  },
  mpaGlNotes: {
    width: '17%',
  },
  glAmount: {
    width: '10%',
  },
  liAmount: {
    width: '12%',
  },
  liContent: {
    width: '14%',
  },
  hcSmall: {
    width: '25%',
  },
  hcBig: {
    width: '50%',
  },
});
